"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isString;
/**
 * Checks whether or not a value is a string.
 *
 * @param {any} value evaluate if string
 * @returns {boolean} isString
 */
function isString(value) {
  return typeof value === 'string';
}